<!-- CARGADOR -->
<jqxLoader #loader [imagePosition]="'top'" [width]="60" [height]="60" [text]="'Espere...'">
</jqxLoader>

<div class="panel panel-primary my-1 mx-auto rounded-3 shadow-lg" style="height: 99%">
    <div class="panel-heading clearfix">
        <div class="row">
            <div class="col-md-4"></div>
            <div class="col-md-5">
                <div class="panel-title pull-left">
                    <span style="font-size: x-large;">Menús aplicaciones</span>
                </div>
            </div>
            <div class="col-md-3"></div>
        </div>
    </div>

    <!-- FILTROS -->
    <div class="m-2 p-2 rounded-3 borderFilter" style="height: 50px;">
    </div>

    <!-- TABLA GRID -->
    <div class="m-4 row" style="height: 85%;">

        <div class="col-10">
            <!-- <h5>Aplicaciones</h5> -->
            <jqxGrid #grid [theme]="environment.tema" [width]="'100%'" [height]="485" [source]="dataAdapter"
                [columnsresize]="true" [localization]="langGrid" [filterable]="true" [showfilterrow]="true"
                [columns]="columns" [showrowlines]="false" [showcolumnlines]="true" [pageable]="false" [sortable]="true"
                [altrows]="true" [showstatusbar]="true" [statusbarheight]="20" [showaggregates]="true" [rowsheight]="20"
                [columnsheight]="20" [enabletooltips]="true" [editable]="true" [selectionmode]="'singlecell'"
                [groupable]="true" (onCellendedit)="onCellEndEdit($event)">
            </jqxGrid>
        </div>

    </div>
</div>